<template >
  <div class="auth-container is-flex justify-center align-center">
    <div class="auth-form">
      <el-card>
        <login-form></login-form>
      </el-card>
      <el-collapse class="announcement">
        <el-collapse-item title="系統安全升級公告【請注意】" name="announcement" class="announcement-title">
          <p v-for="(item, index) in announcements" :key="index" class="announcement-list">{{ item }}</p>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import LoginForm from '@/components/Login/Form.vue';
export default {
  components: {
    LoginForm,
  },
  data() {
    return {
      announcements: [
        '🔐 系統安全升級公告',
        '為符合更嚴格的資訊安全標準，本平台已完成帳號安全機制強化更新，主要影響以下流程：',
        '  - 忘記密碼：改採驗證碼確認機制，重設後所有裝置將自動登出',
        '  - 新使用者啟用：改由系統寄送驗證碼，由使用者自行設定密碼',
        '  - 密碼強度要求提升：新密碼需至少 12 碼，包含大小寫、數字及特殊符號',
        '如有任何問題，請聯繫客服。感謝您的配合。',
      ],
    };
  },
};
</script>

<style lang="stylus" scoped>
.auth-container
  height 100%
.auth-form
  max-width 600px
  width 100%
.announcement
  margin-top 16px
.announcement-title
  ::v-deep .el-collapse-item__header
    font-size 24px
.announcement-list
  font-size 16px
.no-border
  border-width 0
</style>
